import { render, staticRenderFns } from "./SdTime.vue?vue&type=template&id=42d8b3ca&scoped=true"
import script from "./SdTime.vue?vue&type=script&lang=js"
export * from "./SdTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8b3ca",
  null
  
)

export default component.exports